module.exports = __webpack_public_path__ + "img/az.89a17da7.svg";